export default "__VITE_ASSET__c1d8e666__"